"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Index {
    constructor(parent) {
        this.parent = parent;
        this.rc = parent.rc;
    }
    path() {
        return `${this.parent.path()}/notes`;
    }
    /**
     * Returns the list of chat notes.
     * HTTP Method: get
     * Endpoint: /team-messaging/v1/chats/{chatId}/notes
     * Rate Limit Group: Heavy
     * App Permission: TeamMessaging
     */
    async get(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(), queryParams, restRequestConfig);
        return r.data;
    }
    /**
     * Creates a new note in the specified chat.
     * HTTP Method: post
     * Endpoint: /team-messaging/v1/chats/{chatId}/notes
     * Rate Limit Group: Medium
     * App Permission: TeamMessaging
     */
    async post(tMCreateNoteRequest, restRequestConfig) {
        const r = await this.rc.post(this.path(), tMCreateNoteRequest, undefined, restRequestConfig);
        return r.data;
    }
}
exports.default = Index;
//# sourceMappingURL=index.js.map